import styled from 'styled-components';
import { device, typography } from '@/styles/helpers';

export const ScSpinsCounter = styled.div`
  width: fit-content;
  display: flex;
  position: relative;
  align-items: center;
  padding: 0 8px;
  border-radius: 8px;
  ${typography.headline2mobile};
  color: ${({ theme }) => theme.whiteColor};
  text-transform: uppercase;
  height: 32px;
  background-color: ${({ theme }) => theme.blackColor};
  @media (${device.mobile}) {
    ${typography.body2bold};
    text-transform: none;
  }
`;
